import React from 'react';
import {createPortal} from 'react-dom';
import PageButton from '../../elements/PageButton/PageButton';
import {getLeagueConfig} from '../../../configs/leagues';
import '../../Header/InGameMenu/InGameMenu.css';
import './SpectatorsModal.css';
import {useGameUiPortalTarget} from '../../gameUi/GameUiPortal';

const PAGE_ID = 'SpectatorsModal';

/**
 * Список зрителей матча — открывается счетчиком в шапке боковой панели
 * (см. SpectatorsCount).
 *
 * Оформление то же, что у игрового меню: та же панель .in-game-menu на своем
 * затемнении, те же кнопки — окно открывается из матча и должно читаться как
 * его часть, а не как наградная модалка с греческими рамками.
 *
 * Зрители приходят в дескрипторе лобби (сервер шлет его и игрокам, и зрителям):
 * сам факт записи в списке и означает «смотрит», поэтому статус тут не
 * показывается — у чужих клиентов он может застрять на «offline», а запись
 * зрителя сервер удаляет вместе с его сокетом. Лигу зритель приносит оттуда
 * же: сервер считает ее по рейтингу в момент входа.
 *
 * Рисуется порталом в корень экрана матча по той же причине, что и BotControlModal: шапка
 * живет внутри боковой панели, и обычная модалка оказалась бы под ней. И так
 * же не заводится флагом modalVisibility — у зрителя всплывающие окна скрыты
 * галочкой, а этот список нужен в первую очередь ему
 *
 * @param {Object} props
 * @param {Array<{id: string, name: string}>} props.spectators
 * @param {Function} props.onClose
 */
const SpectatorsModal = ({spectators = [], onClose}) => {
  const portalTarget = useGameUiPortalTarget();

  return createPortal(
    <div
      className={'modal-window_overlay'}
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
    >
      <div className={'in-game-menu spectators-modal'} onClick={(e) => e.stopPropagation()}>
        <h2 className={'spectators-modal_title'}>Зрители</h2>

        {spectators.length === 0 ? (
          <div className={'spectators-modal_note'}>Сейчас за игрой никто не наблюдает.</div>
        ) : (
          <ul className={'spectators-modal_list'}>
            {spectators.map((spectator) => {
              const league = getLeagueConfig(spectator.leagueId);
              return (
                <li className={'spectators-modal_item'} key={spectator.id}>
                  {league && (
                    <img
                      className={'spectators-modal_league-icon'}
                      src={league.iconPath}
                      alt={league.name}
                      title={league.name}
                    />
                  )}
                  <span className={'spectators-modal_name'}>{spectator.name}</span>
                </li>
              );
            })}
          </ul>
        )}

        <div className={'menu-buttons'}>
          <PageButton onClick={onClose} pageId={PAGE_ID} buttonId={'close'}>Закрыть</PageButton>
        </div>
      </div>
    </div>,
    portalTarget
  );
};

export default SpectatorsModal;
